/* ---- pubsub + constants ---- */
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error"
};
let subscribers = {};
function subscribe($, t) {
  if (subscribers[$] === undefined) {
    subscribers[$] = [];
  }
  subscribers[$] = [...subscribers[$], t];
  return function x() {
    subscribers[$] = subscribers[$].filter($ => $ !== t);
  };
}
function publish($, t) {
  if (subscribers[$]) {
    subscribers[$].forEach($ => {
      $(t);
    });
  }
}

/* ---- misc helpers (parsed html, focusables) ---- */
function fixParsedHtml($, t) {
  let e = $.querySelector(".cart-drawer__body");
  if (e) {
    let i = document.querySelector("cart-drawer");
    i.cartBodyScroll = e.scrollTop;
  }
  let s = t.querySelector(".cart-timer");
  if (s && (oldTimer = $.querySelector(".cart-timer"))) {
    s.innerHTML = oldTimer.innerHTML;
  }
  let a = $.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let r = t.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  a.forEach(($, t) => {
    let i = r[t];
    if (i) {
      if ($.nodeName.toLowerCase() === "cart-drawer-upsell") {
        i.dataset.selected = $.dataset.selected;
      }
      i.dataset.id = $.dataset.id;
      i.querySelector("[name=\"id\"]").value = $.querySelector("[name=\"id\"]").value;
      if (i.querySelector(".upsell__image__img")) {
        i.querySelector(".upsell__image__img").src = $.querySelector(".upsell__image__img").src;
      }
      if (i.querySelector(".upsell__variant-picker")) {
        let s = $.querySelectorAll(".select__select");
        i.querySelectorAll(".select__select").forEach(($, t) => {
          $.value = s[t].value;
          $.querySelectorAll("option").forEach($ => {
            $.removeAttribute("selected");
            if ($.value === s[t].value.trim()) {
              $.setAttribute("selected", "");
            }
          });
        });
      }
      if ($.dataset.updatePrices === "true") {
        var a = i.querySelector(".upsell__price");
        var n = $.querySelector(".upsell__price");
        if (a && n) {
          a.innerHTML = n.innerHTML;
        }
      }
    }
  });
}
function serializePropValue($) {
  if ($ == null) {
    return "";
  }
  if (typeof $ === "object") {
    try {
      return JSON.stringify($);
    } catch {}
  }
  return String($);
}
function getFocusableElements($) {
  return Array.from($.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

/* ---- focus trap, media, quantity input, utils ---- */
const trapFocusHandlers = {};
function trapFocus($, t = $) {
  var e = getFocusableElements($);
  var i = e[0];
  var s = e[e.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = t => {
    if (t.target === $ || t.target === s || t.target === i) {
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    }
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (t) {
    if (t.code.toUpperCase() === "TAB") {
      if (t.target === s && !t.shiftKey) {
        t.preventDefault();
        i.focus();
      }
      if ((t.target === $ || t.target === i) && t.shiftKey) {
        t.preventDefault();
        s.focus();
      }
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  t.focus();
  if (t.tagName === "INPUT" && ["search", "text", "email", "url"].includes(t.type) && t.value) {
    t.setSelectionRange(0, t.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(t => {
    t.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(t => {
    t.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(t => t.pause());
  document.querySelectorAll("product-model").forEach(t => {
    if (t.modelViewerUI) {
      t.modelViewerUI.pause();
    }
  });
}
;
function removeTrapFocus($ = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if ($) {
    $.focus();
  }
}
function onKeyUpEscape($) {
  if ($.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  let x = $.target.closest("details[open]");
  if (!x) {
    return;
  }
  let e = x.querySelector("summary");
  x.removeAttribute("open");
  e.setAttribute("aria-expanded", false);
  e.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(t => t.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange($) {
    this.validateQtyRules();
  }
  onButtonClick($) {
    $.preventDefault();
    let x = this.input.value;
    if ($.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (x !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    let t = parseInt(this.input.value);
    if (this.input.min) {
      let x = parseInt(this.input.min);
      let e = this.querySelector(".quantity__button[name='minus']");
      e.classList.toggle("disabled", t <= x);
    }
    if (this.input.max) {
      let i = parseInt(this.input.max);
      let s = this.querySelector(".quantity__button[name='plus']");
      s.classList.toggle("disabled", t >= i);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(t);
    }
  }
}
function debounce($, t) {
  let x;
  return (...e) => {
    clearTimeout(x);
    x = setTimeout(() => $.apply(this, e), t);
  };
}
function fetchConfig($ = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + $
    }
  };
}
function addDays($, t) {
  var x = new Date($);
  x.setDate(x.getDate() + t);
  return x;
}
function formatDates($, t, x = 27) {
  if (!$ || !t) {
    return;
  }
  let i = new Date(t + "T00:00:00Z");
  let s = i.getFullYear();
  let a = i.getMonth();
  let r = i.getDate();
  let n = new Date(s, a, r);
  return Math.ceil(($ - n) / 86400000) <= x;
}
customElements.define("quantity-input", QuantityInput);

/* ---- legacy Shopify helpers ---- */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function ($, t) {
  return function () {
    return $.apply(t, arguments);
  };
};
Shopify.setSelectorByValue = function ($, t) {
  for (var e = 0, i = $.options.length; e < i; e++) {
    var s = $.options[e];
    if (t == s.value || t == s.innerHTML) {
      $.selectedIndex = e;
      return e;
    }
  }
};
Shopify.addListener = function ($, t, x) {
  if ($.addEventListener) {
    $.addEventListener(t, x, false);
  } else {
    $.attachEvent("on" + t, x);
  }
};
Shopify.postLink = function ($, t) {
  var e = (t = t || {}).method || "post";
  var i = t.parameters || {};
  var s = document.createElement("form");
  s.setAttribute("method", e);
  s.setAttribute("action", $);
  for (var a in i) {
    var r = document.createElement("input");
    r.setAttribute("type", "hidden");
    r.setAttribute("name", a);
    r.setAttribute("value", i[a]);
    s.appendChild(r);
  }
  document.body.appendChild(s);
  s.submit();
  document.body.removeChild(s);
};

/* ---- country/province selector ---- */
Shopify.CountryProvinceSelector = function ($, t, x) {
  this.countryEl = document.getElementById($);
  this.provinceEl = document.getElementById(t);
  this.provinceContainer = document.getElementById(x.hideElement || t);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var t = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, t);
    this.countryHandler();
  },
  initProvince: function () {
    var t = this.provinceEl.getAttribute("data-default");
    if (t && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, t);
    }
  },
  countryHandler: function ($) {
    var x = this.countryEl.options[this.countryEl.selectedIndex];
    var e = x.getAttribute("data-provinces");
    var i = JSON.parse(e);
    this.clearOptions(this.provinceEl);
    if (i && i.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var s = 0; s < i.length; s++) {
        var x = document.createElement("option");
        x.value = i[s][0];
        x.innerHTML = i[s][1];
        this.provinceEl.appendChild(x);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function ($) {
    while ($.firstChild) {
      $.removeChild($.firstChild);
    }
  },
  setOptions: function ($, t) {
    for (var e = 0; e < t.length; e++) {
      var i = document.createElement("option");
      i.value = t[e];
      i.innerHTML = t[e];
      $.appendChild(i);
    }
    t.length;
  }
};

/* ---- product price/variant helpers ---- */
function updatePdpPrices($, t, x, e) {
  let s = formatMoney($, e);
  let a = formatMoney(t, e);
  let r = t > $;
  let n = document.querySelectorAll(".price-" + x);
  n.forEach(x => {
    x.classList.toggle("price--on-sale", r);
    x.querySelector(".price__regular .price-item--regular").innerHTML = s;
    x.querySelector(".price__sale .price-item--sale").innerHTML = s;
    if (r) {
      let l = x.querySelector(".price__sale .price-item--regular");
      if (l) {
        l.innerHTML = a;
      }
      let h = x.querySelector(".badge__percentage-saved");
      if (h) {
        h.innerHTML = Math.round((t - $) * 100 / t);
      }
      let c = x.querySelector(".badge__money-saved");
      if (c) {
        let d = formatMoney(t - $, e, true);
        c.innerHTML = d;
      }
    }
  });
  let l = document.querySelectorAll(".main-atc-price-span-" + x);
  l.forEach($ => {
    $.innerHTML = s;
  });
}
function updateVariantStatuses($, t, x = false) {
  t.forEach((e, i) => {
    if (i === 0) {
      return;
    }
    let a = [...e.querySelectorAll("option")];
    let r = t[i - 1].querySelector(":checked").value;
    let n = $.filter($ => $.available && $["option" + i] === r).map($ => $["option" + (i + 1)]);
    let l = $.filter($ => $["option" + i] === r).map($ => $["option" + (i + 1)]);
    a.forEach($ => {
      $.classList.remove("unavailable", "non-existent");
      $.removeAttribute("disabled");
      $.removeAttribute("hidden");
      if (l.includes($.getAttribute("value"))) {
        if (n.includes($.getAttribute("value"))) {
          $.innerText = $.getAttribute("value");
        } else {
          $.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value"));
          $.classList.add("unavailable");
          if (x) {
            $.setAttribute("disabled", "");
            $.setAttribute("hidden", "");
          }
        }
      } else {
        $.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value"));
        $.classList.add("non-existent");
        $.setAttribute("disabled", "");
        $.setAttribute("hidden", "");
      }
    });
  });
}
function findAvailableVariant($, t, x = true, e = false, i = false) {
  for (let a = t.length - 1; a >= 0; a--) {
    let r = x ? $.querySelector(".product-form__input:nth-child(" + (a + 1) + ")") : $.querySelectorAll(".select")[a];
    let n = x ? r.querySelector(".product-form__input__type").dataset.type : "dropdown";
    let l = n === "dropdown" ? r.querySelectorAll("option") : r.querySelectorAll("input[type=\"radio\"]");
    let h = Array.from(l).findIndex($ => $.value === t[a]);
    let c = false;
    while (h < l.length - 1) {
      h++;
      let d = l[h];
      if ((!e || !d.classList.contains("non-existent")) && (!i || !d.classList.contains("unavailable"))) {
        t[a] = d.value;
        c = true;
        break;
      }
    }
    if (!c) {
      for (h = Array.from(l).findIndex($ => $.value === t[a]); h > 0;) {
        h--;
        let o = l[h];
        if ((!e || !o.classList.contains("non-existent")) && (!i || !o.classList.contains("unavailable"))) {
          t[a] = o.value;
          c = true;
          break;
        }
      }
    }
    if (c) {
      if (n === "dropdown") {
        r.querySelector(".select__select").value = t[a];
      } else {
        r.querySelector("input[type=\"radio\"][value=\"" + t[a] + "\"]").checked = true;
      }
      $.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
function updateGiftGoalInStorage({
  giftHandle: $,
  giftVariantId: t,
  unlockType: x,
  unlockRequirement: e,
  unlockTarget: i
}) {
  let a = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!$ || !t || !e || !x) {
    return;
  }
  let r = {
    type: x,
    gift_handle: $,
    gift_variant_id: Number(t),
    unlock_product_handle: i || null
  };
  if (x === "product_variant") {
    if (Array.isArray(e)) {
      r.valid_variants = e.map($ => String($).toLowerCase().trim());
    } else {
      r.valid_variants = [String(e).toLowerCase().trim()];
    }
  } else {
    r.required_quantity = Number(e);
  }
  a[$] = r;
  localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(a));
}

/* ---- money formatting ---- */
function displayPrices($, t, x, e, i) {
  if (i) {
    if ($ && x) {
      var a = formatMoney($, i);
      x.innerHTML = a;
    }
    if (t && e) {
      var r = formatMoney(t, i);
      e.innerHTML = r;
      if (t > $) {
        e.classList.remove("hidden");
      } else {
        e.classList.add("hidden");
      }
    }
  }
}
function formatMoney($, t, x = false) {
  if (typeof $ == "string") {
    $ = $.replace(".", "");
  }
  var i = "";
  var s = /\{\{\s*(\w+)\s*\}\}/;
  var a = t;
  function r($, t) {
    if (typeof $ == "undefined") {
      return t;
    } else {
      return $;
    }
  }
  function n($, t, e, i) {
    t = r(t, 2);
    e = r(e, ",");
    i = r(i, ".");
    if (isNaN($) || $ == null) {
      return 0;
    }
    var a = ($ = ($ / 100).toFixed(t)).split(".");
    var n = a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e);
    var l = a[1] ? i + a[1] : "";
    if (x && l === i + "00") {
      l = "";
    }
    return n + l;
  }
  switch (a.match(s)[1]) {
    case "amount":
      i = n($, 2);
      break;
    case "amount_no_decimals":
      i = n($, 0);
      break;
    case "amount_with_comma_separator":
      i = n($, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = n($, 0, ".", ",");
  }
  return a.replace(s, i);
}

/* ---- focus-visible polyfill ---- */
try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
const defaultDirection =
    document.currentScript && "true" === document.currentScript.dataset.isRtl
      ? "rtl"
      : "ltr",
  isRtl = "rtl" === defaultDirection;
function focusVisiblePolyfill() {
  let t = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (t) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || (e = document.activeElement).classList.add("focused"));
      },
      !0,
    ));
}

/* ---- menu drawer / header drawer ---- */
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      (this.mainOpenBtn = this.mainDetailsToggle.querySelector("summary")),
      (this.stickyOpenBtn = this.querySelector(".drawer__sticky-open")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((t) =>
      t.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll(
        "button:not(.menu-drawer__close-menu-btn):not(.drawer__sticky-open):not(.localization-v2__button)",
      ).forEach((t) =>
        t.addEventListener("click", this.onCloseButtonClick.bind(this)),
      ),
      this.stickyOpenBtn &&
        ("after_scrolling" === this.stickyOpenBtn.dataset.display &&
          (this.checkStickyBtnScroll(),
          document.addEventListener(
            "scroll",
            this.checkStickyBtnScroll.bind(this),
          )),
        this.stickyOpenBtn.addEventListener("click", () => {
          (this.mainDetailsToggle.setAttribute("open", ""),
            this.openMenuDrawer(this.mainOpenBtn, !0));
        })));
  }
  onKeyUp(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    let e = t.target.closest("details[open]");
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            t,
            this.mainDetailsToggle.querySelector("summary"),
          )
        : this.closeSubmenu(e));
  }
  onSummaryClick(t) {
    let e = t.currentTarget,
      i = e.parentNode,
      s = e.nextElementSibling;
    (!s || s.classList.contains("hidden")) && (s = i.nextElementSibling);
    let n = i.closest(".has-submenu"),
      r = i.hasAttribute("open"),
      o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function a() {
      let t = i.querySelector("button") || s.querySelector("button") || s;
      (trapFocus(s, t), s.removeEventListener("transitionend", a));
    }
    i === this.mainDetailsToggle
      ? (r && t.preventDefault(),
        r ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`,
          ))
      : setTimeout(() => {
          (i.classList.add("menu-opening"),
            e.setAttribute("aria-expanded", !0),
            n && n.classList.add("submenu-open"),
            !o || o.matches ? a() : s.addEventListener("transitionend", a));
        }, 100);
  }
  openMenuDrawer(t, e = !1) {
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      t.setAttribute("aria-expanded", !0),
      e || trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(
        `overflow-hidden-${this.dataset.breakpoint}`,
      ));
  }
  closeMenuDrawer(t, e = !1) {
    void 0 !== t &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((t) => {
        (t.removeAttribute("open"), t.classList.remove("menu-opening"));
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t) => {
        t.classList.remove("submenu-open");
      }),
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      ),
      removeTrapFocus(e),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(t) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    let e = t.currentTarget.dataset.details
      ? document.getElementById(t.currentTarget.dataset.details)
      : t.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(t) {
    let e = t.closest(".submenu-open");
    (e && e.classList.remove("submenu-open"),
      t.classList.remove("menu-opening"),
      t.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(t.querySelector("summary")),
      this.closeAnimation(t));
  }
  closeAnimation(t) {
    let e,
      i = (s) => {
        void 0 === e && (e = s);
        let n = s - e;
        n < 400
          ? window.requestAnimationFrame(i)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
              trapFocus(
                t.closest("details[open]"),
                t.querySelector("summary"),
              ));
      };
    window.requestAnimationFrame(i);
  }
  checkStickyBtnScroll() {
    let t = this.mainOpenBtn.getBoundingClientRect().top + window.scrollY + 20;
    window.scrollY > t
      ? this.stickyOpenBtn.classList.remove("hidden")
      : this.stickyOpenBtn.classList.add("hidden");
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    (super(),
      this.querySelectorAll(".menu-drawer__close-menu-btn").forEach((t) =>
        t.addEventListener("click", this.closeButtonClick.bind(this)),
      ));
  }
  openMenuDrawer(t) {
    ((this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom",
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(
        `overflow-hidden-${this.dataset.breakpoint}`,
      ));
  }
  closeMenuDrawer(t, e) {
    (super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open"));
  }
  closeButtonClick(t) {
    (this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")),
      this.querySelector(
        ".header__icon--menu[aria-expanded=true]",
      ).setAttribute("aria-expanded", "false"));
  }
}
customElements.define("header-drawer", HeaderDrawer);

/* ---- modal dialog, modal opener, deferred media, copy button ---- */
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1),
      ),
      this.addEventListener("keyup", (t) => {
        "ESCAPE" === t.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (t) => {
            "mouse" !== t.pointerType ||
              t.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (t) => {
            t.target === this && this.hide();
          }));
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    let e = this.querySelector(".template-popup");
    (document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector(
      "button:not(.internal-video__play, .internal-video__sound-btn)",
    );
    if (!t) return;
    t.addEventListener("click", () => {
      let e = document.querySelector(this.getAttribute("data-modal"));
      e && e.show(t);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector('[id^="Deferred-Poster-"]');
    if (!t) return;
    t.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(t = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let e = document.createElement("div");
      (e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0),
      ),
        this.setAttribute("loaded", !0));
      let i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
      t && i.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
  constructor() {
    (super(),
      (this.textarea = document.createElement("textarea")),
      this.textarea.classList.add("visually-hidden"),
      (this.textarea.value = this.dataset.content.trim()),
      this.appendChild(this.textarea),
      this.addEventListener("click", this.handleClick.bind(this)));
  }
  handleClick(t) {
    (this.textarea.select(),
      document.execCommand("copy"),
      (this.dataset.success = "true"),
      setTimeout(() => (this.dataset.success = "false"), 3e3));
  }
}
customElements.define("copy-button", CopyButton);

/* ---- slider component ---- */
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      (this.hasDots = !1),
      (this.scrollMultiplier = isRtl ? -1 : 1),
      (this.verticalDesktop = "true" === this.dataset.desktopVertical),
      (this.verticalMobile = "true" === this.dataset.mobileVertical),
      (this.vertical = !1),
      !this.slider || !this.nextButton)
    )
      return;
    (this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      this.sliderControlWrapper &&
        this.sliderControlWrapper.querySelector(".slider-counter__link") &&
        (this.pagination.length < 2 && (document.body.innerHTML = ""),
        (this.internalVideos = this.querySelectorAll("internal-video")),
        (this.pauseVideos =
          "true" === this.dataset.pauseVideos &&
          this.internalVideos.length > 0),
        (this.sliderFirstItemNode =
          this.slider.querySelector(".slider__slide")),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((t) =>
          t.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        (this.hasDots = !0)),
      this.initPages());
    let t = new ResizeObserver((t) => this.initPages());
    t.observe(this.slider);
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.sliderControlLinksArray.indexOf(t.currentTarget),
      i = 0;
    for (let s = 0; s < e; s++)
      this.sliderControlLinksArray[s].classList.contains("hidden") && i++;
    let n = e - i,
      r = n + 1 - this.currentPage,
      o = this.vertical
        ? this.slider.scrollTop
        : this.slider.scrollLeft * this.scrollMultiplier,
      a = this.vertical
        ? this.sliderFirstItemNode.clientHeight
        : this.sliderFirstItemNode.clientWidth,
      l = o + a * r;
    this.vertical
      ? this.slider.scrollTo({ top: l, behavior: "smooth" })
      : this.slider.scrollTo({
          left: l * this.scrollMultiplier,
          behavior: "smooth",
        });
  }
  initPages() {
    if (
      (window.innerWidth < 750
        ? (this.vertical = this.verticalMobile)
        : (this.vertical = this.verticalDesktop),
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (t) => t.clientWidth > 0,
      )),
      !(this.sliderItemsToShow.length < 2))
    ) {
      if (this.vertical) {
        let t = this.sliderItemsToShow[0].offsetTop;
        ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - t),
          (this.slidesPerPage = Math.floor(
            (this.slider.clientHeight - t) / this.sliderItemOffset,
          )),
          (this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1));
      } else {
        let e = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - e),
          (this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - e) / this.sliderItemOffset,
          )),
          (this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1));
      }
      this.update();
    }
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    let t = this.currentPage;
    if (
      (this.vertical
        ? (this.currentPage =
            Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1)
        : (this.currentPage =
            Math.round(
              (this.slider.scrollLeft * this.scrollMultiplier) /
                this.sliderItemOffset,
            ) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.hasDots)
    ) {
      let e = 0,
        i = this.currentPage - 1;
      this.sliderControlLinksArray.forEach((t, s) => {
        (t.classList.remove("slider-counter__link--active"),
          t.removeAttribute("aria-current"),
          !t.classList.contains("hidden") &&
            (e === i &&
              (t.classList.add("slider-counter__link--active"),
              t.setAttribute("aria-current", "true")),
            e++));
      });
    }
    let s = this.sliderItems[this.currentPage - 1];
    (this.pauseVideos &&
      s &&
      this.internalVideos.forEach((t) => {
        s.id != t.closest('[id^="Slide-"]').id &&
          ("true" === t.dataset.autoplay
            ? ((t.querySelector("video").muted = !0),
              t.classList.add("internal-video--muted"))
            : (t.querySelector("video").pause(),
              t.classList.remove("internal-video--playing")));
      }),
      this.enableSliderLooping ||
        (this.vertical
          ? (0 === this.slider.scrollTop
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(
              this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
              !0,
            )
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled"))
          : (this.isSlideVisible(this.sliderItemsToShow[0]) &&
            0 === this.slider.scrollLeft
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(
              this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
              !0,
            )
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled"))));
  }
  isSlideVisible(t, e = !1, i = 0, s = !1) {
    let n = e ? 10 : 0;
    if (this.vertical) {
      let r = t.offsetTop + t.clientHeight,
        o = t.offsetTop,
        a = this.slider.scrollTop - n + i,
        l = this.slider.scrollTop + this.slider.clientHeight + n - i;
      return r <= l && (!s || o >= a);
    }
    {
      let d = t.offsetLeft * this.scrollMultiplier + t.clientWidth,
        c = t.offsetLeft * this.scrollMultiplier,
        h = this.slider.scrollLeft * this.scrollMultiplier - n + i,
        u =
          this.slider.scrollLeft * this.scrollMultiplier +
          this.slider.clientWidth +
          n -
          i;
      return d <= u && (!s || c >= h);
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    let e = t.currentTarget.dataset.step || 1;
    if (this.vertical) {
      let i = this.slider.scrollTop,
        s;
      ((s =
        "next" === t.currentTarget.name
          ? i + e * this.sliderItemOffset
          : i - e * this.sliderItemOffset),
        this.slider.scrollTo({ top: s, behavior: "smooth" }));
    } else {
      let n = this.slider.scrollLeft * this.scrollMultiplier;
      ((this.slideScrollPosition =
        "next" === t.currentTarget.name
          ? n + e * this.sliderItemOffset
          : n - e * this.sliderItemOffset),
        this.slider.scrollTo({
          left: this.slideScrollPosition * this.scrollMultiplier,
          behavior: "smooth",
        }));
    }
  }
}
customElements.define("slider-component", SliderComponent);

/* ---- details disclosure, header menu, details modal ---- */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      (this.content =
        this.mainDetailsToggle.querySelector("summary").nextElementSibling),
      this.mainDetailsToggle.addEventListener(
        "focusout",
        this.onFocusOut.bind(this),
      ),
      this.mainDetailsToggle.addEventListener(
        "toggle",
        this.onToggle.bind(this),
      ));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onToggle() {
    (this.animations || (this.animations = this.content.getAnimations()),
      this.mainDetailsToggle.hasAttribute("open")
        ? this.animations.forEach((t) => t.play())
        : this.animations.forEach((t) => t.cancel()));
  }
  close() {
    (this.mainDetailsToggle.removeAttribute("open"),
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", !1));
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    (super(), (this.header = document.querySelector(".header-wrapper")));
  }
  onToggle() {
    this.header &&
      ((this.header.preventHide = this.mainDetailsToggle.open),
      "" ===
        document.documentElement.style.getPropertyValue(
          "--header-bottom-position-desktop",
        ) &&
        document.documentElement.style.setProperty(
          "--header-bottom-position-desktop",
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
        ));
  }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
  constructor() {
    (super(),
      (this.detailsContainer = this.querySelector("details")),
      (this.summaryToggle = this.querySelector("summary")),
      this.detailsContainer.addEventListener(
        "keyup",
        (t) => "ESCAPE" === t.code.toUpperCase() && this.close(),
      ),
      this.summaryToggle.addEventListener(
        "click",
        this.onSummaryClick.bind(this),
      ),
      this.querySelector('button[type="button"]').addEventListener(
        "click",
        this.close.bind(this),
      ),
      this.summaryToggle.setAttribute("role", "button"));
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(t) {
    (t.preventDefault(),
      t.target.closest("details").hasAttribute("open")
        ? this.close()
        : this.open(t));
  }
  onBodyClick(t) {
    (!this.contains(t.target) ||
      t.target.classList.contains("modal-overlay")) &&
      this.close(!1);
  }
  open(t) {
    ((this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this)),
      t.target.closest("details").setAttribute("open", !0),
      document.body.addEventListener("click", this.onBodyClickEvent),
      document.body.classList.add("overflow-hidden"),
      "function" == typeof trapFocus &&
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          this.detailsContainer.querySelector('input:not([type="hidden"])'),
        ));
  }
  close(t = !0) {
    ("function" == typeof removeTrapFocus &&
      removeTrapFocus(t ? this.summaryToggle : null),
      this.detailsContainer.removeAttribute("open"),
      document.body.removeEventListener("click", this.onBodyClickEvent),
      document.body.classList.remove("overflow-hidden"));
  }
}
customElements.define("details-modal", DetailsModal);

/* ---- sticky group manager (header) ---- */
class StickyGroupManager extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.stickyElements = []),
      this.collectStickyElements(),
      0 !== this.stickyElements.length &&
        ((this.currentScrollTop = 0),
        (this.preventReveal = !1),
        (this.groupBoundsBottom = 0),
        this.updateHeightsAndOffsets(),
        (this.mediaQuery = window.matchMedia("(max-width: 990px)")),
        this.mediaQuery.addEventListener(
          "change",
          this.updateHeightsAndOffsets.bind(this),
        ),
        (this.resizeObserver = new ResizeObserver(() => {
          this.updateHeightsAndOffsets();
        })),
        this.stickyElements.forEach((t) => {
          t.contentElement && this.resizeObserver.observe(t.contentElement);
        }),
        this.createObserver(),
        (this.onScrollHandler = this.onScroll.bind(this)),
        window.addEventListener("scroll", this.onScrollHandler, !1),
        (this.hideOnScrollUp = () => (this.preventReveal = !0)),
        this.addEventListener("preventHeaderReveal", this.hideOnScrollUp)));
  }
  collectStickyElements() {
    let t = this.querySelectorAll("sticky-header"),
      e = this.querySelectorAll("sticky-announcement"),
      i = [...e, ...t];
    (i.sort((t, e) => {
      let i = t.compareDocumentPosition(e);
      return i & Node.DOCUMENT_POSITION_FOLLOWING
        ? -1
        : i & Node.DOCUMENT_POSITION_PRECEDING
          ? 1
          : 0;
    }),
      i.forEach((t, e) => {
        let i = t.dataset.stickyType || "none";
        if ("none" === i) return;
        let s = "always" === i || "reduce-logo-size" === i,
          n = "sticky-header" === t.tagName.toLowerCase(),
          r;
        ((r = n
          ? t.closest(".section-header") || t.parentElement
          : t.closest(".shopify-section") || t.parentElement),
          this.stickyElements.push({
            element: t,
            contentElement: r,
            type: i,
            index: e,
            height: 0,
            isHidden: !1,
            isAlwaysSticky: s,
            isHeader: n,
          }),
          (t.dataset.managedByGroup = "true"),
          s && r && r.classList.add("shopify-section-header-sticky"));
      }));
  }
  updateHeightsAndOffsets() {
    let t = 0;
    (this.stickyElements.forEach((e) => {
      if (e.contentElement) {
        e.height = e.contentElement.getBoundingClientRect().height;
        let i = Math.ceil(e.height);
        e.isHeader
          ? e.contentElement.style.setProperty("--header-height", `${i}px`)
          : e.contentElement.style.setProperty(
              "--announcement-bar-height",
              `${i}px`,
            );
      }
      let s = Math.floor(t);
      (e.element.style.setProperty("--sticky-offset", `${s}px`),
        e.contentElement &&
          e.contentElement.style.setProperty("--sticky-offset", `${s}px`),
        e.isHidden || (t += e.height));
    }),
      document.documentElement.style.setProperty(
        "--sticky-group-height",
        `${Math.floor(t)}px`,
      ));
    let e = this.stickyElements.find((t) => t.isHeader);
    e &&
      document.documentElement.style.setProperty(
        "--header-height",
        `${Math.ceil(e.height)}px`,
      );
  }
  createObserver() {
    let t = new IntersectionObserver((t) => {
      this.groupBoundsBottom = t[0].boundingClientRect.bottom;
    });
    t.observe(this);
  }
  onScroll() {
    let t = window.scrollY || document.documentElement.scrollTop,
      e = t > this.currentScrollTop,
      i = t < this.currentScrollTop,
      s = this.getBoundingClientRect(),
      n = t > s.height,
      r = t <= 0,
      o = this.stickyElements.some((t) => {
        if (t.isHeader) {
          let e = t.element.querySelector("predictive-search");
          return e && e.isOpen;
        }
        return !1;
      });
    if (o) {
      this.currentScrollTop = t;
      return;
    }
    (this.stickyElements.forEach((t) => {
      if (r) this.resetElement(t);
      else if (n) {
        if ((t.contentElement?.classList.add("scrolled-past-header"), e)) {
          if (this.preventHide) return;
          requestAnimationFrame(() => this.hideElement(t));
        } else
          i &&
            (this.preventReveal
              ? (clearTimeout(this.isScrolling),
                (this.isScrolling = setTimeout(() => {
                  this.preventReveal = !1;
                }, 66)),
                requestAnimationFrame(() => this.hideElement(t)))
              : requestAnimationFrame(() => this.revealElement(t)));
      } else
        t.isAlwaysSticky &&
          (t.contentElement?.classList.add("scrolled-past-header"),
          this.revealElement(t));
    }),
      (this.currentScrollTop = t));
  }
  hideElement(t) {
    !t.isAlwaysSticky &&
      t.contentElement &&
      ((t.isHidden = !0),
      t.contentElement.classList.add(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
      ),
      this.updateVisibleOffsets(),
      t.element.dispatchEvent(new CustomEvent("stickyHide", { bubbles: !0 })));
  }
  revealElement(t) {
    t.contentElement &&
      ((t.isHidden = !1),
      t.contentElement.classList.add(
        "shopify-section-header-sticky",
        "animate",
      ),
      t.contentElement.classList.remove("shopify-section-header-hidden"),
      this.updateVisibleOffsets(),
      t.element.dispatchEvent(
        new CustomEvent("stickyReveal", { bubbles: !0 }),
      ));
  }
  resetElement(t) {
    if (t.contentElement) {
      if (
        (t.contentElement.classList.remove("scrolled-past-header"),
        t.isAlwaysSticky)
      ) {
        t.element.dispatchEvent(
          new CustomEvent("stickyReset", { bubbles: !0 }),
        );
        return;
      }
      ((t.isHidden = !1),
        t.contentElement.classList.remove(
          "shopify-section-header-hidden",
          "shopify-section-header-sticky",
          "animate",
        ),
        this.updateVisibleOffsets(),
        t.element.dispatchEvent(
          new CustomEvent("stickyReset", { bubbles: !0 }),
        ));
    }
  }
  updateVisibleOffsets() {
    let t = 0;
    (this.stickyElements.forEach((e) => {
      let i = Math.floor(t);
      (e.element.style.setProperty("--sticky-offset", `${i}px`),
        e.contentElement &&
          e.contentElement.style.setProperty("--sticky-offset", `${i}px`),
        e.isHidden || (t += e.height));
    }),
      document.documentElement.style.setProperty(
        "--sticky-group-height",
        `${Math.floor(t)}px`,
      ));
  }
  disconnectedCallback() {
    (window.removeEventListener("scroll", this.onScrollHandler),
      this.mediaQuery?.removeEventListener(
        "change",
        this.updateHeightsAndOffsets.bind(this),
      ),
      this.removeEventListener("preventHeaderReveal", this.hideOnScrollUp),
      this.resizeObserver?.disconnect());
  }
}
customElements.define("sticky-group-manager", StickyGroupManager);

/* ---- moved from cart.js ---- */
const GIFTS_LOCAL_STORAGE_KEY = "yuna_gift_goals";

/* ---- moved from cart.js ---- */
function removeLocalStorageGift($) {
  let t = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (t) {
    try {
      let x = JSON.parse(t);
      if (x && x[$.gift_handle]) {
        delete x[$.gift_handle];
        localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(x));
      }
    } catch (e) {
      console.warn("Error parsing gift localStorage data:", e);
    }
  }
}

/* ---- moved from infinite-products.js ---- */
function _formatPresentmentMoney(t, e) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || void 0, {
      style: "currency",
      currency: e,
    }).format(t / 100);
  } catch (i) {
    return (t / 100).toFixed(2) + " " + e;
  }
}

/* ---- moved from infinite-products.js ---- */
function _getPresentmentRate(t) {
  let e =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active,
    i =
      window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
  if (!e || !i || e === t) return null;
  let s = parseFloat(i);
  return s && 1 !== s ? { active: e, rate: s } : null;
}
